import React from 'react';
import ChatAnalysis from './Teto_vs_egen/ChatAnalysis.jsx';

function ChatPage() {
    return (
        <div style={{ paddingTop: '80px', minHeight: '100vh', background: '#0b0f14' }}>
            <ChatAnalysis />
        </div>
    );
}

export default ChatPage;
